
export default function DSAR() {

    // Make an AJAX request for the regions for the selected country
    function updateCountryRegions() {
        if ($('#dsar-form #country').val() && $('#dsar-form #country').val().length === 2) {
            const countryCode = $('#dsar-form #country').val();
            const data = {countryCode};

            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams && urlParams.get('lang')) {
                data.lang = urlParams.get('lang');
            }

            $.ajax('/wp-json/tcc/v1/dsar/countryRegions/', {
                type: 'GET',
                data,
                timeout: 99000,
            })
                .done((response) => {
                    if (response.data && response.data[0]) {
                        $('#state_or_province').empty().append('<option value=""></option>'); // require a non-empty selection

                        Object.keys(response.data[0]).forEach((key) => {
                            const value = response.data[0][key];
                            $('#state_or_province').append(`<option value="${key}">${value}</option>`);
                        });
                    }
                })
                .fail((jqXHR, textStatus) => {
                    console.log(`error: ${textStatus}`);
                    $('#state_or_province').prop('required', false); // Waive requirement so form can be submitted
                });
        }
    }


    // DSAR form parsley validation
    $('#dsar-form').parsley();


    // Select All/Unselect All functionality
    $(document).ready(function () {
        const $selectAllBtn = $('#dsar-select-all-brands');
        const $unselectAllBtn = $('#dsar-unselect-all-brands');
        const $brandSelect = $('#brand');

        // Ensure the placeholder option is not selected by default
        $brandSelect.find('option[value=""]').prop('selected', false);

        if ($selectAllBtn.length && $unselectAllBtn.length && $brandSelect.length) {
            // Select All logic
            $selectAllBtn.on('click', function () {
                $selectAllBtn.addClass('dsar-hide');
                $unselectAllBtn.removeClass('dsar-hide');

                // Select all options in the <select>
                $brandSelect.find('option[value!=""]:not(:last-child)').prop('selected', true);
            });

            // Unselect All logic
            $unselectAllBtn.on('click', function () {
                $unselectAllBtn.addClass('dsar-hide');
                $selectAllBtn.removeClass('dsar-hide');

                // Unselect all options in the <select>
                $brandSelect.find('option').prop('selected', false);
            });
            
            // if the last brand item is selected, no other should be, and conversely...
            $brandSelect.on('change', function () {
                const $options = $brandSelect.find('option');
                const $lastOption = $options.last(); // Last option
                const selectedValues = $brandSelect.val(); // Get selected values (array)

                // If the last option is selected, deselect all other options
                if (selectedValues && selectedValues.includes($lastOption.val())) {
                    $options.not($lastOption).prop('selected', false);
                }

                // If any other options are selected, deselect the last option
                else {
                    $lastOption.prop('selected', false);
                }
            });

        } else {
            console.warn("Select All/Unselect All buttons or brand select element not found on the page.");
        }
    });

    // DSAR form 'other' request handling
    const $requestTypeOther = $('#request_type_other');
    const $requestType = $('#dsar-form #request_type').on('change', () => {
        if ($requestType.val() === 'other') {
            $requestTypeOther.show();
            $requestTypeOther.attr('data-parsley-required', 'true');
        } else {
            $requestTypeOther.hide();
            $requestTypeOther.attr('data-parsley-required', 'false');
        }
    });

    // User changed language for DSAR form
    $('#dsarlang').on('change', () => {
        window.location = `/privacy/dsar/?lang=${$('#dsarlang').val()}`;
    });

    if ($('#dsar-form #country').val() && $('#dsar-form #country').val().length === 2) {
        // Country geodetected on the server so dropdown has a value but no change event occurred.
        // Make an AJAX request to load regions for the geodetected country.
        updateCountryRegions();
    }

    // User selected a country on DSAR form. Load subregions
    $('#dsar-form #country').on('change', () => {
        updateCountryRegions();
    });

    // send email verify code
    const $email = $('#dsar-form #email')
    const $sendVerifyMessage = $('#dsar-form .send_verify_message')
    const $sendVerifyError = $('#dsar-form .send_verify_error')
    const $sendVerifyButton = $('#dsar-form #send_verify').on('click', () => {
        if (!$email.val() || !$email.parsley().isValid()) {
            $sendVerifyError.removeClass('hidden');
            return false;
        }
        $('#dsar-form #send_verify').prop('disabled', true);
        $sendVerifyError.addClass('hidden');
        $sendVerifyMessage.addClass('hidden');

        const urlParams = new URLSearchParams(window.location.search);
        const data = {
            email: $email.val(),
            lang: urlParams.get('lang'),
        };

        $.ajax('/wp-json/tcc/v1/dsar/sendverifycode/', {
            type: 'POST',
            data,
            timeout: 99000,
        })
            .done(() => {
                console.info('verify email sent');
            })
            .fail((jqXHR, textStatus) => {
                console.log(`error: ${textStatus}`);
            });

        $sendVerifyMessage.removeClass('hidden');

        return false;
    });

    // enable request code button when email field changes
    $email.on('keyup', () => {
        $sendVerifyButton.prop('disabled', false);
    });

    // enable submit button when verify code is entered
    const $verifyCode = $('#dsar-form #verify_code').on('keyup', () => {
        if ($verifyCode.parsley().isValid()) {
            $('#dsar-form #submit_button').prop('disabled', false);
        } else {
            $('#dsar-form #submit_button').prop('disabled', true);
        }
    });
}
